import { Button } from '@/components/ui';
import { useNavigate, Link } from 'react-router-dom';

import { useDaoConfig } from '@/hooks/useDaoConfig';

export default function LoginPage() {
  const navigate = useNavigate();
  const { daoName, workerRole, clientRole } = useDaoConfig();

  return (
    <div className="onboardingContent">
      {/* Top right button to Login */}
      <div className="signupBtn">
        <span>Don't have an account yet?</span>
        <Button variant="secondary" onClick={() => navigate('/register')}>
          Sign up
        </Button>
      </div>
      <div className="title">
        <h1>Welcome to {daoName}</h1>
        <p>Select your account type to continue</p>
      </div>

      <div className="space-y-[--spacing-8]">
        <Link to="/login/developer" className="block group roleCard">
          <div className="roleCard__checkbox group-hover:bg-[--state-brand-active]">
            <i className="ri-check-line innerIcon group-hover:opacity-100" />
          </div>
          <div className="roleCard__info">
            <h2>{workerRole}</h2>
            <p>Login as a {workerRole.toLowerCase()} to work on assigned tasks and milestones</p>
          </div>
        </Link>

        <Link to="/login/client" className="block group roleCard">
          <div className="roleCard__checkbox group-hover:bg-[--state-brand-active]">
            <i className="ri-check-line innerIcon group-hover:opacity-100" />
          </div>
          <div className="roleCard__info">
            <h2>{clientRole}</h2>
            <p>Login as a {clientRole.toLowerCase()} to manage your projects and milestones</p>
          </div>
        </Link>
      </div>

      {/* Divider */}
      <div className="w-full flex items-center gap-[--spacing-9]">
        <div className="flex-1 h-[1px] bg-[--base-fill-1]" />
        <span className="text-xs text-[--text-dark-tertiary] italic">
          Wallet authentication
        </span>
        <div className="flex-1 h-[1px] bg-[--base-fill-1]" />
      </div>

      {/* Wallet button */}
      <Link to="/login/wallet" className="block">
        <div className="flex cursor-pointer items-center gap-4 rounded-xl border border-[--base-border] bg-[--base-surface-2] p-5 transition-all hover:opacity-90">
          {/* Wallet icon cluster */}
          <div className="flex shrink-0 items-center -space-x-2">
            {/* Talisman */}
            <div className="z-[3]">
              <svg
                width="28"
                height="28"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rounded-[--radi-4] outline outline-2 outline-[--base-surface-2]"
              >
                <rect width="32" height="32" rx="8" fill="#D5FF5C" />
                <path
                  d="M16 6C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6z"
                  fill="#1A1A1A"
                />
                <path
                  d="M16 9a7 7 0 100 14A7 7 0 0016 9zm0 2a5 5 0 110 10A5 5 0 0116 11z"
                  fill="#D5FF5C"
                />
              </svg>
            </div>

            {/* Polkadot.js */}
            <div className="z-[2]">
              <svg
                width="28"
                height="28"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rounded-[--radi-4] outline outline-2 outline-[--base-surface-2]"
              >
                <rect width="32" height="32" rx="8" fill="#E6007A" />
                <circle cx="16" cy="16" r="6" fill="white" />
                <circle cx="16" cy="7" r="2.5" fill="white" />
                <circle cx="16" cy="25" r="2.5" fill="white" />
                <circle cx="7" cy="16" r="2.5" fill="white" />
                <circle cx="25" cy="16" r="2.5" fill="white" />
              </svg>
            </div>

            {/* SubWallet */}
            <div className="z-[1]">
              <svg
                width="28"
                height="28"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rounded-[--radi-4] outline outline-2 outline-[--base-surface-2]"
              >
                <rect width="32" height="32" rx="8" fill="#4CEAAC" />
                <path
                  d="M10 12h12M10 16h8M10 20h10"
                  stroke="#1A1A1A"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>

          <div className="min-w-0 flex-1">
            <h2 className="mb-0.5 text-base font-semibold text-[--text-dark-primary]">
              Polkadot Wallet — unavailable
            </h2>

            <p className="text-sm text-[--text-dark-secondary]">Not supported by the current backend</p>
          </div>

          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="shrink-0 text-[--text-dark-tertiary]"
          >
            <path
              d="M6 3l5 5-5 5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </Link>

      {/* <div className="mt-6 text-center">
        <p className="text-sm text-[--text-dark-secondary]">
          Don't have an account?{' '}
          <Link
            to="/register"
            className="font-medium text-[var(--state-brand-active,#36d399)] hover:underline"
          >
            Sign up
          </Link>
        </p>
      </div> */}
    </div>
  );
}
